<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Services</h3>
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Services</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="services-widget-area pt-50 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span class="sp-before sp-after">Services</span>
            <h2 class="h2-color">We’re Flexible to <b>Provide You Best</b></h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon1.png" alt="Images"></a>
                    <h3><a routerLink="/services">Web Apps / Websites</a></h3>
                    <p>We showcase your precise ideas in the website development and help in elevating your brand value.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>

          

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon3.png" alt="Images"></a>
                    <h3><a routerLink="/services">Mobile Applications</a></h3>
                    <p>Build and deploy custom mobile applications using iOS, Android, and cross-platform solutions for your business.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon1.png" alt="Images"></a>
                    <h3><a routerLink="/services">E-Governance Consultancy</a></h3>
                    <p>We We provide Our eGovernance Support includes ITcell Management, eoffice Support, Hardware,Software, Network & Social media Support</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div> 

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon5.png" alt="Images"></a>
                    <h3><a routerLink="/services">eOffice Support</a></h3>
                    <p>We provide eoffice implementation and Support which includes Training Support, EMD & Email Support,DSC Support, Infrastructure assessment & Decentralised Admin Management </p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon5.png" alt="Images"></a>
                    <h3><a routerLink="/services">ITcell Management</a></h3>
                    <p>We manage Government Department IT cell management includes eoffice support, Hardware,Software, Network support ,Intermediatory support , Website Management & Social Media Support </p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon6.png" alt="Images"></a>
                    <h3><a routerLink="/services">Google Business</a></h3>
                    <p>We helps to grow your business through management of google business profilr and google ads support.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon1.png" alt="Images"></a>
                    <h3><a routerLink="/services">AI Videos</a></h3>
                    <p>Grow your business online by awesomely designed AI videos that fits all types of businesses.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>


       

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon4.png" alt="Images"></a>
                    <h3><a routerLink="/services">Graphic Designing</a></h3>
                    <p>Deliver an engaging customer experience by creating attractive Graphic designs includes design of logos,ads,brochures,flyers.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services"><img src="assets/img/service/service-icon2.png" alt="Images"></a>
                    <h3><a routerLink="/services">Social Media</a></h3>
                    <p>We offers Social media optimization services, Instagram, Facebook Page management, Regular Ads, Lead generation etc.</p>
                    <div class="services-card-shape"><img src="assets/img/service/service-shape.png" alt="Images"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="counter-area-two pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3> 70+</h3>
                    <p>Projects Completed</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>100%</h3>
                    <p>Satishfaction Rate</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>10+</h3>
                    <p>Team Memebers</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>25+</h3>
                    <p>OnGoing Projects</p>
                </div>
            </div>
        </div>
    </div>

    <div class="counter-shape-top"><img src="assets/img/counter/counter-shape.png" alt="Images"></div>
</div>

<div class="work-area-two pt-100 pb-70" >
    <div class="container">
        <div class="section-title text-center">
            <span class="sp-before sp-after">Working Process</span>
            <h2 class="h2-color2">Design & Development</h2>
            <p> </p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-12">
                <div class="work-item-list">
                    <ul>
                        <li class="text-end">
                            <h3>Planning <span>1</span></h3>
                            
                        </li>
                        <li class="text-end">
                            <h3>Design &  Development <span>2</span></h3>
                            
                        </li>
                        <li class="text-end">
                            <h3>Testing<span>3</span></h3>
                            
                        </li> </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="work-img-2">
                    <img src="assets/img/work-img.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="work-item-list-2">
                    <ul>
                        <li>
                            <h3><span>4</span>Documenting</h3>
                            
                        </li>
                        <li>
                            <h3><span>5</span>Deploy & Delivery</h3>
                            
                        </li>
                      
                        <li>
                            <h3><span>6</span>Support/ Maintainance</h3>
                            
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>




<app-footer-style-two></app-footer-style-two>